<template>
  <div class="FIconBtn" @click="getPath()" :class="{FIconBtn_Disabled:disabled}">
    <div :class="{addBtn:$store.state.FaPath === path}">
      <svg viewBox="0 0 1024 1024" version="1.1" v-html="svgList[title]" v-if="svgList[title]" :style="{width:IconSize+'px',height:IconSize+'px'}"></svg>
      <slot>{{title||'按钮'}}</slot>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/7 2:40 下午
 */
import config from '@/assets/js/config'

export default {
  name: 'FIconBtn',
  components: {},
  props: {
    title: {
      type: String,
      default: '按钮'
    },
    path: {
      type: String,
      default: ''
    },
    IconSize: {
      type: Number,
      default: 24
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      svgList: {
        '数据接入': '<path d="M513.13777778 1021.04177778c-15.13244445 0-30.37866667-3.86844445-43.80444445-11.71911111L219.59111111 865.84888889c-12.62933333-7.28177778-16.95288889-23.43822222-9.78488889-36.06755556 7.28177778-12.62933333 23.43822222-17.06666667 36.06755556-9.78488888l249.62844444 143.58755555c10.80888889 6.25777778 24.23466667 6.25777778 35.04355556 0l249.62844444-143.58755555c12.62933333-7.28177778 28.78577778-2.95822222 36.06755556 9.78488888 7.28177778 12.62933333 2.95822222 28.78577778-9.78488889 36.06755556L556.94222222 1009.32266667c-13.42577778 7.85066667-28.672 11.71911111-43.80444444 11.71911111zM895.43111111 466.60266667c-14.56355555 0-26.39644445-11.83288889-26.39644444-26.39644445v-77.93777777c0-1.36533333-0.79644445-2.73066667-2.048-3.52711112L515.29955555 156.672c-1.36533333-0.79644445-3.072-0.79644445-4.32355555 0L159.28888889 358.85511111c-1.25155555 0.68266667-2.048 2.048-2.048 3.52711111V440.32c0 14.56355555-11.83288889 26.39644445-26.39644444 26.39644445s-26.39644445-11.83288889-26.39644445-26.39644445v-77.93777778c0-20.25244445 10.92266667-39.13955555 28.55822222-49.26577777L484.69333333 110.93333333c17.63555555-10.12622222 39.48088889-10.12622222 57.00266667 0l351.68711111 202.18311112c17.63555555 10.12622222 28.55822222 29.01333333 28.55822222 49.26577777V440.32c-0.11377778 14.44977778-11.94666667 26.28266667-26.51022222 26.28266667z M409.71377778 131.75466667a103.424 102.85511111 0 1 0 206.848 0 103.424 102.85511111 0 1 0-206.848 0Z M513.13777778 261.12c-71.56622222 0-129.82044445-58.02666667-129.82044445-129.25155555 0-71.33866667 58.25422222-129.25155555 129.82044445-129.25155556s129.82044445 58.02666667 129.82044444 129.25155556c0 71.22488889-58.25422222 129.25155555-129.82044444 129.25155555z m0-205.824c-42.43911111 0-77.02755555 34.24711111-77.02755556 76.45866667S470.69866667 208.21333333 513.13777778 208.21333333s77.02755555-34.24711111 77.02755555-76.45866666c0-42.09777778-34.58844445-76.45866667-77.02755555-76.45866667z M30.37866667 639.54488889a103.424 102.85511111 0 1 0 206.848 0 103.424 102.85511111 0 1 0-206.848 0Z M133.80266667 768.79644445c-71.56622222 0-129.82044445-58.02666667-129.82044445-129.25155556 0-71.22488889 58.25422222-129.25155555 129.82044445-129.25155556s129.82044445 58.02666667 129.82044444 129.25155556c0 71.22488889-58.25422222 129.25155555-129.82044444 129.25155556z m0-205.71022223c-42.43911111 0-77.02755555 34.24711111-77.02755556 76.45866667s34.58844445 76.45866667 77.02755556 76.45866666 77.02755555-34.36088889 77.02755555-76.45866666c0-42.21155555-34.58844445-76.45866667-77.02755555-76.45866667z M789.04888889 639.54488889a103.424 102.85511111 0 1 0 206.848 0 103.424 102.85511111 0 1 0-206.848 0Z M892.47288889 768.79644445c-71.56622222 0-129.82044445-58.02666667-129.82044444-129.25155556 0-71.22488889 58.25422222-129.25155555 129.82044444-129.25155556 71.56622222 0 129.82044445 58.02666667 129.82044444 129.25155556 0.11377778 71.22488889-58.14044445 129.25155555-129.82044444 129.25155556z m0-205.71022223c-42.43911111 0-77.02755555 34.24711111-77.02755556 76.45866667s34.58844445 76.45866667 77.02755556 76.45866666c42.43911111 0 77.02755555-34.36088889 77.02755556-76.45866666 0.11377778-42.21155555-34.47466667-76.45866667-77.02755556-76.45866667z"></path>',
        '数据准备': '<path d="M841.81902222 409.20177778L1021.72444445 293.54666667 512 2.27555555 2.27555555 293.54666667l179.90542223 115.65511111L2.27555555 512l149.9136 96.38115555L2.27555555 694.04444445l509.72444445 327.68 509.72444445-327.68-149.9136-85.6632889L1021.72444445 512z m39.54915556 288.50631111L512 935.16231111l-369.36817778-237.45422222 78.63182223-44.93084444L512 839.68l290.73635555-186.90275555zM800.51768889 567.63733333l-69.06311111 44.37333334L512 753.11786667l-219.4432-141.08444445-69.06311111-44.37333333-80.85048889-51.97368889 108.61226667-62.06577778 80.85048888 51.97368889 69.06311112 44.37333334L512 621.22666667l110.83093333-71.24764445 69.06311112-44.37333333 80.85048888-51.97368889 108.61226667 62.06577778z"></path>',
        '多维分析': '<path d="M896 921.6H128c-70.656 0-128-57.344-128-128V230.4c0-70.656 57.344-128 128-128h768c70.656 0 128 57.344 128 128v563.2c0 70.656-57.344 128-128 128zM128 153.6c-42.496 0-76.8 34.304-76.8 76.8v563.2c0 42.496 34.304 76.8 76.8 76.8h768c42.496 0 76.8-34.304 76.8-76.8V230.4c0-42.496-34.304-76.8-76.8-76.8H128z M256 486.4c-70.656 0-128-57.344-128-128s57.344-128 128-128 128 57.344 128 128-57.344 128-128 128z m0-204.8c-42.496 0-76.8 34.304-76.8 76.8s34.304 76.8 76.8 76.8 76.8-34.304 76.8-76.8-34.304-76.8-76.8-76.8zM204.8 742.4c-7.68 0-15.36-3.584-20.48-10.24-8.704-11.264-6.144-27.136 5.12-35.84l181.76-136.192c21.504-15.872 49.664-19.968 74.752-9.728l198.144 79.36c9.728 3.584 20.48 1.536 27.648-5.632l129.536-129.536c10.24-10.24 26.112-10.24 36.352 0s10.24 26.112 0 36.352L708.096 660.48c-21.504 21.504-54.272 28.672-82.944 16.896l-198.144-79.36c-8.192-3.072-17.92-2.048-25.088 3.072L220.16 737.28c-4.608 3.584-10.24 5.12-15.36 5.12z"></path>',
        '原生分析': '<path d="M509.973333 85.333333L106.666667 316.714667v464.853333L380.501333 938.666667l82.773334-48.832L191.573333 732.757333V365.525333l318.4-182.549333 318.421334 182.549333v367.232l-273.834667 157.077334L639.466667 938.666667l273.834666-157.077334V316.714667z" fill="#2c2c2c" p-id="2018"></path><path d="M240.405333 707.285333l269.568 154.965334 269.589334-154.965334v-97.642666l-269.589334 154.965333-269.568-154.965333z" fill="#2c2c2c" p-id="2019"></path><path d="M240.405333 550.208l269.568 157.077333 269.589334-157.077333v-97.642667l-269.589334 157.077334-269.568-157.077334z" fill="#2c2c2c" p-id="2020"></path><path d="M779.562667 395.242667l-269.589334-157.077334-269.568 157.077334 269.568 154.965333z" fill="#2c2c2c" p-id="2021"></path>',
        '查找用户': '<path d="M974.995261 981.333333a42.276571 42.276571 0 0 1-42.22781 42.666667H90.74688A42.276571 42.276571 0 0 1 48.51907 981.333333s7.021714-146.968381 121.953524-203.824762c72.704-35.59619 44.568381-19.017143 133.705143-54.564571 89.136762-35.547429 110.201905-61.635048 110.201905-61.635048l-4.632381-47.396571s-98.499048-28.42819-114.93181-137.508571c-30.524952 7.168-39.887238-33.158095-42.227809-59.196953-2.340571-26.087619-18.773333-106.691048 18.773333-99.571809-7.070476-54.51581-14.09219-101.912381-9.411047-128 4.681143-42.666667-7.021714-49.737143 32.865523-82.944 9.362286-9.508571-9.411048-49.785905-2.340571-61.635048 11.702857-23.747048 91.428571-14.238476 103.18019-19.017143A327.43619 327.43619 0 0 1 505.856975 0c168.911238 7.119238 234.544762 99.57181 243.95581 189.635048 2.340571 26.087619-2.340571 73.48419-11.702857 128 37.546667-7.119238 21.113905 73.48419 18.773333 99.571809-2.389333 26.038857-11.702857 68.754286-42.22781 59.245714-16.432762 109.031619-96.158476 137.508571-96.158476 137.508572l-4.729905 45.007238s21.113905 23.698286 110.250667 61.635048c89.136762 35.547429 60.952381 21.308952 133.705143 56.856381C967.924785 831.975619 974.995261 981.333333 974.995261 981.333333z" p-id="1336"></path>',
        '用户列表管理': '<path d="M425.752408 853.440893a85.279553 85.279553 0 0 0 0 170.466913h779.962186a85.279553 85.279553 0 1 0 0-170.466913z m-340.472855 0a85.279553 85.279553 0 1 0 85.279554 85.279554 85.279553 85.279553 0 0 0-85.279554-85.279554M425.752408 426.858738a85.279553 85.279553 0 0 0 0 170.466912h779.962186a85.279553 85.279553 0 1 0 0-170.466912m-1120.250652 0a85.187359 85.187359 0 1 0 60.018366 24.89241 85.279553 85.279553 0 0 0-60.294949-24.984604m1120.527235-255.838661a85.463942 85.463942 0 1 0 0-170.927883h-779.962186a85.279553 85.279553 0 1 0 0 170.466913zM0 85.279553A85.187359 85.187359 0 1 0 24.984604 24.984604 85.279553 85.279553 0 0 0 0 85.279553z" p-id="2909"></path>',

      }
    }
  },
  methods: {
    getPath() {
      if (this.path && !this.disabled) {
        if (this.$store.state.FaPath === this.path) {
          return;
        }
        if (this.$route.path !== this.path) {
          this.getRouterPath(this.path);
        }
      }
    },
  },
  mounted() {
  },
  destroyed() {

  }
}
</script>

<style lang="less">
.FIconBtn {
  vertical-align: middle;

  > div {
    .com_btn;
    background-color: #fff;
    transition: 0.1s;
    height: 50px;
    line-height: 50px;
    color: #999;
    margin-bottom: 38px;

    > svg {
      vertical-align: middle;
      margin-right: 8px;
      margin-top: -5px;
      width: 24px;
      height: 24px;

      > path {
        fill: #666;
      }
    }
  }

  .addBtn {
    color: #002774;
    position: relative;

    > svg {
      path {
        fill: #002774;
      }
    }
  }
  .addBtn::after {
    content: "";
    width: 10px;
    height: 50px;
    background-color: #002774;
    border-radius: 10px;
    position: absolute;
    right: -21px;
  }
}


.FIconBtn_Disabled {
  > div {
    background-color: #f5f5f5 !important;
    border-color: #d5d5d5 !important;
    cursor: not-allowed !important;

    > svg {
      fill: #666 !important;
    }

    > span {
      color: #666 !important;
    }
  }
}
</style>